/*
 * @Author: wzh
 * @LastEditTime: 2022-11-01 17:44:04
 * @Description: 单点登录 index
 */
import SimplyLogin from "./simplyLogin";
export { SimplyLogin };
